import { translate } from '@/domains/core/localization/translate';
export const {
  renameWishlistModalLabel,
  renameWishlistModalTitle,
  renameWishlistModalInputError,
  renameWishlistModalIndication,
  renameWishlistModalActionButtonText,
  renameWishlistOperationError,
  renameWishlistOperationSuccess,
  deleteWishlistModalTitle,
  deleteWishlistModalIndication,
  deleteWishlistModalActionButtonText,
  deleteWishlistOperationError,
  deleteWishlistOperationSuccess,
  createNewWishlistModalTitle,
  createNewWishlistModalLabel,
  createNewWishlistOperationError,
  createNewWishlistModalInputError,
  createNewWishlistModalIndication,
  createNewWishlistOperationSuccess,
  createNewWishlistModalActionButtonText
} = translate({
  "renameWishlistModalActionButtonText": "Rename",
  "renameWishlistModalTitle": "Rename wishlist",
  "renameWishlistModalIndication": "Find a new name for your wishlist",
  "renameWishlistModalLabel": "Name of your wishlist",
  "renameWishlistModalInputError": "This field is required",
  "renameWishlistOperationError": "An error has occurred",
  "renameWishlistOperationSuccess": "Wishlist renamed",
  "deleteWishlistModalActionButtonText": "Delete wishlist",
  "deleteWishlistModalTitle": "Delete the wishlist",
  "deleteWishlistModalIndication": "Are you sure you want to delete this wishlist and all of the products saved in it?",
  "deleteWishlistOperationError": "An error has occurred",
  "deleteWishlistOperationSuccess": "Wishlist correctly deleted",
  "createNewWishlistModalActionButtonText": "Create",
  "createNewWishlistModalTitle": "Create new wishlist",
  "createNewWishlistModalIndication": "Name your wishlist",
  "createNewWishlistModalLabel": "Wishlist name",
  "createNewWishlistModalInputError": "This field is required",
  "createNewWishlistOperationError": "An error occurred while creating your wishlist",
  "createNewWishlistOperationSuccess": "Wishlist correctly created"
});